module.exports = __webpack_public_path__ + "img/131w.9504fd7.jpg";